import { GoogleMap, Marker, InfoWindow, LatLng, Polygon, Polyline, useLoadScript } from "@react-google-maps/api";
import React from "react";
import { useState, useEffect, useMemo } from 'react';
import { route } from "./data";
import axios from "axios";
import "./App.css";

function MapaLive() {
	
const usePaths = initialValue => {
  const [devicepaths, setDevicePaths] = React.useState(new Map(initialValue));

  const actions = React.useMemo(
    () => ({
      setPath: (key, value) =>
        setDevicePaths(prevMap => {
          const nextMap = new Map(prevMap);
          nextMap.set(key, value);
          return nextMap;
        }),
      removePath: (key, value) =>
        setDevicePaths(prevMap => {
          const nextMap = new Map(prevMap);
          nextMap.delete(key, value);
          return nextMap;
        }),
      clearPath: () => setDevicePaths(new Map()),
    }),
    [setDevicePaths]
  )
  
  return [devicepaths, actions];
};

const useMarkers = initialValue => {
  const [devicemarkers, setDeviceMarkers] = React.useState(new Map(initialValue));

  const actions = React.useMemo(
    () => ({
      setMarker: (key, value) =>
        setDeviceMarkers(prevMap => {
          const nextMap = new Map(prevMap);
          nextMap.set(key, value);
          return nextMap;
        }),
      removeMarker: (key, value) =>
        setDeviceMarkers(prevMap => {
          const nextMap = new Map(prevMap);
          nextMap.delete(key, value);
          return nextMap;
        }),
      clearMarker: () => setDeviceMarkers(new Map()),
    }),
    [setDeviceMarkers]
  )
  
  return [devicemarkers, actions];
};
	
  const [activeMarker, setActiveMarker] = useState(null);
  const [onlinedevices, setOnlineDevices] = useState([]);
  const [onlinedevicesdataloaded, setOnlineDevicesDataLoaded] = useState(false);
  const [markeri, setMarkeri] = useState([]);
  
  const [date, setDate] = useState(new Date().toLocaleTimeString());
	
  const [trophies, setTrophies] = useState([]);
 
  const [devicepaths, { setPath, removePath, clearPath }] = usePaths([[]]);
  
  const [devicemarkers, { setMarker, removeMarker, clearMarker }] = useMarkers([[]]);
  
  
  
  const [firstload, setFirstLoad] = useState(true);
  const [markerlocation, setMarkerLocation] = useState({ lat: 0, lng: 0 });
  const [geoData, setGeoData] = useState({ lat: 43, lng: 18 });
  
  const [trophiesdataloaded, setTrophiesDataLoaded] = useState(false);
  
  	const [id, setId] = useState(localStorage.getItem('id'));	
	const [subscriberId, setSubscriberId] = useState(localStorage.getItem('subscriberId'));
	const [ime, setIme] = useState('');
	const [tip, setTip] = useState('');
	const [IMEI, setIMEI] = useState('0');
	const [tiptrackera, setTiptrackera] = useState('');
	const [brojmobitela, setBrojmobitela] = useState('');
	const [bojaputanje, setBojaputanje] = useState('');
	const [uploadinterval, setUploadinterval] = useState('');
	const [needreset, setNeedreset] = useState('');
	const [workmode, setWorkmode] = useState('');
	const [setuploadinterval, setSetuploadinterval] = useState('');
	const [blokiran, setBlokiran] = useState('');
	const [datumstart, setDatumstart] = useState('');
	const [datumend, setDatumend] = useState('');
	const [datumlast, setDatumlast] = useState('');
	const [brojlokacija, setBrojlokacija] = useState('');
	
	const markers = [];

  const handleActiveMarker = (marker) => {
    if (marker === activeMarker) {
      return;
    }
    setActiveMarker(marker);
  };
		
	const svgMarker = {
    path: "M29.395,0H17.636c-3.117,0-5.643,3.467-5.643,6.584v34.804c0,3.116,2.526,5.644,5.643,5.644h11.759   c3.116,0,5.644-2.527,5.644-5.644V6.584C35.037,3.467,32.511,0,29.395,0z M34.05,14.188v11.665l-2.729,0.351v-4.806L34.05,14.188z    M32.618,10.773c-1.016,3.9-2.219,8.51-2.219,8.51H16.631l-2.222-8.51C14.41,10.773,23.293,7.755,32.618,10.773z M15.741,21.713   v4.492l-2.73-0.349V14.502L15.741,21.713z M13.011,37.938V27.579l2.73,0.343v8.196L13.011,37.938z M14.568,40.882l2.218-3.336   h13.771l2.219,3.336H14.568z M31.321,35.805v-7.872l2.729-0.355v10.048L31.321,35.805",
    fillColor: "red",
    fillOpacity: 2,
    strokeWeight: 1,
    rotation: 0,
    scale: 0.7,
  };
  
  const SERVER_URL = process.env.REACT_APP_BACKEND_SERVER_URL;
	
  useEffect(() => { 
  
	console.log(onlinedevicesdataloaded);
	
  	if (!onlinedevicesdataloaded) {
		getOnlineDevices();
	}  
	
	if (onlinedevicesdataloaded) {
		onlinedevices.map((device, index) => {
		console.log(device.IMEI);
			
			var offset = Math.floor(Math.random() * 10)*20;
			setTimeout(() => {
			console.log("Delayed for " + offset + " second.");
			getPathforDevice(device);
			
			/*
			const interval = setInterval(() => {
				getPathforDevice(device);	
			}, 10000);
			*/
			
			}, 1000);
		});
	}

	// return () => clearInterval(interval);
  }, [onlinedevicesdataloaded, devicemarkers]);
 
  const getOnlineDevices = async () => {
    try {
        const response = await axios.get(SERVER_URL + "/devices" + "?IMEI=" + localStorage.getItem('IMEI'));
        setOnlineDevices(response.data);
		setOnlineDevicesDataLoaded(true);
		// console.log(response.data);
    } catch (err) {
		console.log("error");
    }
  };
  
  const getPathforDevice = async (device) => {
    try {
      const response = await axios.get(SERVER_URL + "/gpsrecords?IMEI=" + device.IMEI);
	  
		var path = response.data;
	    console.log(path);
		path.sort((a,b)=> (a.datumvrijemelokacije.toLowerCase() > b.datumvrijemelokacije.toLowerCase() ? 1 : -1));

	    setPath(device.IMEI, path);
		
		path.map((marker, index) => {
		console.log(marker);
		
		markers.push({
		id: marker.id,
		device: device,
		vlasnik: device.subscriber,
		position: { lat: marker.lat, lng: marker.lng },
		vrijeme: marker.vrijemelokacije
		});
		
		});
		
		console.log(response.data[response.data.length - 1].lat);
		console.log(response.data[response.data.length - 1].lng);
		
		if ((parseFloat(response.data[response.data.length - 1].lat) == response.data[response.data.length - 1].lat) && (parseFloat(response.data[response.data.length - 1].lng) == response.data[response.data.length - 1].lng) ) {
		console.log("Setting marker location...");
		// setGeoData({ lat: response.data[response.data.length - 1].lat, lng: response.data[response.data.length - 1].lng });
		
		/*
		markers.push({
		id: response.data[response.data.length - 1].id,
		device: device,
		vlasnik: device.subscriber,
		position: { lat: response.data[response.data.length - 1].lat, lng: response.data[response.data.length - 1].lng },
		vrijeme: response.data[response.data.length - 1].vrijemelokacije
		});
		*/
		
		setMarkeri(markers);
		
		setGeoData({ lat: response.data[response.data.length - 1].lat, lng: response.data[response.data.length - 1].lng });
		
		}	
      } catch (err) {
        console.log("error");
      }
  };
	
  const { isLoaded } = useLoadScript({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_API_KEY
  });
  
const [polygonPath, setPolygonPath] = useState();

  const polygonOptions = {
    strokeColor: "red",
    strokeOpacity: 1,
    strokeWeight: 3.0,
    fillColor: "red",
    fillOpacity: 0.2,
  };
  
    const polygonOptions1 = {
    strokeColor: "blue",
    strokeOpacity: 1,
    strokeWeight: 3.0,
    fillColor: "red",
    fillOpacity: 0.2,
  };

  const handleOnLoad = (map) => {

	map.setMapTypeId('satellite');

  };

  return (
  <>
	<div>
	{date}
	</div>
  
  	{(isLoaded) ? ( 
    <GoogleMap
      mapContainerClassName="map-container"
      center={geoData}
      zoom={17}
      onLoad={handleOnLoad}
	  onClick={() => setActiveMarker(null)}
    >
	
	{onlinedevices.map((device, index) => {
		return (
		<>
		<Polyline path = {devicepaths.get(device.IMEI)} options = {polygonOptions} key = {index} />	
		</>
		);
    })}	
	
	{markeri.map(({ id, device, vlasnik, position, vrijeme }) => (
        <Marker
          key={id}
          position={position}
          onClick={() => handleActiveMarker(id)}
		  icon={"/assets/icons/navbar/" + device.tip + ".png"}
        >
          {activeMarker === id ? (
            <InfoWindow position={position} onCloseClick={() => setActiveMarker(null)}>
			<div id="iw-container">
                <div class="iw-title">{device.ime}</div>
                <div class="iw-content">
				<p>Model: {device.tiptrackera}</p>
			    <p>IMEI: {device.IMEI}</p>
				<p>Vlasnik: {vlasnik.ime} {vlasnik.prezime}</p>
				<p>Vrijeme: {vrijeme}</p>
                </div>
            </div>	  
            </InfoWindow>
          ) : null}
        </Marker>
    ))}
	
    </GoogleMap>	
		)
		:
		(
		<>
		</>
		)
	}
  </>
  );
	
}

export default MapaLive;